const ar = {
  language: { label: 'اللغة' },
  nav: {
    gift: 'هدية · 90 يومًا مجانًا',
    pricing: 'الخطط والأسعار',
    features: 'الميزات',
    ecosystem: 'منظومة العائلة',
    clubs: 'الأندية',
    academy: 'الأكاديمية',
    lab: 'ROMIND LAB',
    safety: 'السلامة',
    research: 'الأبحاث',
    insights: 'المقالات',
    about: 'من نحن',
    parentSafety: 'نظرة عامة للوالدين',
    joinTesting: 'الانضمام للاختبار',
    contact: 'تواصل معنا',
    toggleMenu: 'فتح القائمة',
  },
  download: {
    nav: 'تنزيل التطبيق',
    cta: 'تنزيل من Google Play',
    available: 'متاح الآن',
    headline: 'ROMIND KIDS متاح الآن على Google Play!',
    description: 'عالم يجمع الصداقة والإبداع والتعلّم للأطفال من 9 إلى 14 عامًا، مع التركيز على السلامة. نزّل تطبيق Android الآن.',
    scan: 'امسح رمز QR لفتح صفحة ROMIND KIDS على Google Play.',
    qrAlt: 'رمز QR لتنزيل ROMIND KIDS من Google Play',
  },
  footer: {
    tagline: 'عالم إبداعي أكثر أمانًا للأطفال من 9 إلى 14 عامًا — والأساس لمنظومة ROMIND Family Circle.',
    platform: 'المنصة',
    legal: 'قانوني',
    home: 'الرئيسية',
    features: 'ميزات ROMIND KIDS',
    ecosystem: 'منظومة العائلة',
    clubs: 'الأندية والتحديات',
    academy: 'ROMIND Academy',
    lab: 'ROMIND LAB',
    ventureStudio: 'Venture Studio',
    safety: 'السلامة',
    safetyResearch: 'أبحاث السلامة',
    parentSafety: 'نظرة عامة للوالدين',
    insights: 'المقالات',
    joinTesting: 'الانضمام للاختبار',
    about: 'من نحن',
    contact: 'تواصل معنا',
    privacy: 'سياسة الخصوصية',
    terms: 'شروط الخدمة',
    copyright: 'محتوى المستخدم وحقوق النشر',
    community: 'إرشادات المجتمع',
    childSafetyModeration: 'سلامة الأطفال والإشراف',
    reportHandling: 'معالجة البلاغات',
    dataRetention: 'الاحتفاظ بالبيانات وحذفها',
    deleteAccount: 'حذف الحساب',
    childSafetyOverview: 'نظرة عامة على سلامة الأطفال',
    childSafetyResearch: 'أبحاث سلامة الأطفال',
    rights: '© 2025–2026 ROMIND KIDS — مشروع يديره المؤسس. جميع الحقوق محفوظة.',
    safetyPrinciples: 'مصمم وفق مبادئ سلامة الأطفال',
  },
  legal: {
    eyebrow: 'قانوني',
    back: 'العودة إلى ROMIND KIDS',
    lastUpdated: 'آخر تحديث: {date}',
    operatorInfo: 'معلومات المشغّل:',
    otherDocs: 'مستندات قانونية ومستندات سلامة أخرى',
  },
};

export default ar;